import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M16.687 36.01c1.318.128 2.857.395 4.63.87 3.865 1.036 6.74 3.186 9.614 5.337s5.75 4.301 9.613 5.336c7.727 2.071 10.993.185 10.993.185l8.282-30.91s-3.265 1.886-10.993-.184c-3.864-1.035-6.738-3.186-9.613-5.337s-5.75-4.301-9.613-5.336c-7.727-2.07-10.993-.185-10.993-.185l-7.395 27.598a3 3 0 0 0-.096.282l-6 21.03a3 3 0 0 0 5.77 1.647z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }